import ScrollReveal from "@/components/base/ScrollReveal";

export default function AboutSection() {
  return (
    <section id="about" className="relative bg-bg py-20 md:py-28 overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
        backgroundSize: "40px 40px",
      }} />
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-border to-transparent" />
      <div className="absolute -top-32 -right-32 w-[400px] h-[400px] bg-primary/3 rounded-full blur-[100px]" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal>
            <div className="flex items-center gap-3 mb-10">
              <span className="font-sans text-[14px] font-medium text-primary tracking-wider uppercase">
                About
              </span>
              <div className="h-px w-12 bg-primary/30" />
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 lg:gap-14 items-start">
            <ScrollReveal className="lg:col-span-2" direction="left" delay={100}>
              <div className="relative group">
                <div className="absolute -inset-4 bg-gradient-to-br from-primary/15 via-primary/5 to-transparent rounded-[28px] blur-2xl opacity-60 group-hover:opacity-100 transition-opacity duration-700" />
                <div className="relative w-full aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl">
                  <img
                    src="https://static.readdy.ai/image/ff63a95a3d068db59710e28833339873/9db881c9e4333cfdf3dd5df89feaea18.png"
                    alt="Sue Murray - VantageSight Founder"
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
                  />
                </div>
                <div className="mt-6">
                  <h3 className="font-sans text-[24px] font-bold text-text-headline">
                    Sue Murray
                  </h3>
                  <p className="font-sans text-[16px] font-medium text-primary mt-1">
                    Founder and Principal Advisor
                  </p>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal className="lg:col-span-3" direction="right" delay={200}>
              <h2 className="font-serif text-[30px] md:text-[38px] font-semibold text-text-headline leading-tight mb-6">
                <span className="italic text-primary">Senior Advisory Experience</span>{" "}
                in AI Strategy, Governance, Adoption, &amp; Workforce Readiness
              </h2>
              <div className="flex flex-col gap-5 font-sans text-[16px] text-text-muted leading-[1.7]">
                <p>
                  Sue Murray brings 37 years of experience in enterprise technology adoption, with deep expertise in AI strategy, roadmapping, governance, adoption, and workforce planning. She helps organizations cut through AI complexity and create practical, responsible approaches that fit their mission, structure, people, and risk environment.
                </p>
                <p>
                  Her work is especially valuable for organizations that need independent expert guidance, a clear starting point, a governance structure, a practical roadmap, or a quality review of current AI plans.
                </p>
                <p>
                  I do not build AI systems, conduct technical implementation, sell software, or recommend specific AI tools. My role is a trusted independent advisor, providing clarity, focus, guidance, recommendations, and acceleration informed by deep experience and expertise from working with a variety of types of organizations. I help leaders and teams make smart decisions and build the structures needed to follow through.
                </p>
                <p>
                  Whether you are a private sector company, a government agency, an academic or nonprofit institution, or an enterprise team, Sue meets you where you are — with honest conversations, practical advice, and hands-on support that drives real results.
                </p>
              </div>

              <div className="flex flex-wrap gap-3 mt-8">
                {["AI Strategy Advisor", "AI Governance Specialist", "Workforce Readiness", "OCM Expert", "37 Years of Experience"].map(
                  (tag, i) => (
                    <span
                      key={tag}
                      className="font-sans text-[13px] font-medium text-text-body bg-bg-card border border-border px-4 py-2 rounded-full transition-all duration-300 hover:border-primary/40 hover:text-primary cursor-default"
                      style={{ animationDelay: `${i * 50}ms` }}
                    >
                      {tag}
                    </span>
                  )
                )}
              </div>
            </ScrollReveal>
          </div>
        </div>
      </div>
    </section>
  );
}